import logo from "../logo.svg";

export const Loader = () => (
  <div className="App" style={{ backgroundColor: "#D7EADC" }}>
    <img src={logo} className="App-logo" alt="logo" />
    <div>loading...</div>
  </div>
);
